import { render } from "./parameter.vue?vue&type=template&id=fb1f44b8&scoped=true"
import script from "./parameter.vue?vue&type=script&lang=js"
export * from "./parameter.vue?vue&type=script&lang=js"

import "./parameter.vue?vue&type=style&index=0&id=fb1f44b8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_feeder\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1f44b8"]])

export default __exports__